import { Select } from "antd";
import dayjs from "dayjs";
import { ListPage } from "../../components/ListPage";
import { useItemsQuery, useStockLocationsQuery } from "../../helpers/queries";
import { fmtItem } from "../../helpers/format";
import { DT_FORMATS } from "../../helpers/constants";
import type { StockLedgerEntry } from "../../api-models";

const MOVEMENT_TYPES = [
  "OPENING_BALANCE",
  "GRN_RECEIPT",
  "ISSUE_OUT",
  "ISSUE_IN",
  "TRANSFER_DISPATCH",
  "TRANSFER_RECEIPT",
  "RETURN_OUT",
  "RETURN_IN",
  "CONSUMPTION",
  "ADJUSTMENT",
  "REVERSAL",
];

export default function StockLedgerPage() {
  const { data: locations = [] } = useStockLocationsQuery();
  const { data: items = [] } = useItemsQuery();

  return (
    <ListPage<StockLedgerEntry>
      title="Stock Ledger"
      endpoint="/stock/ledger"
      searchPlaceholder="Search by item..."
      filters={({ value, num, set }) => (
        <>
          <Select
            allowClear
            placeholder="Location"
            style={{ width: 220 }}
            options={locations.map((w) => ({ value: w.id, label: w.name }))}
            value={num("locationId")}
            onChange={(v) => set("locationId", v)}
          />
          {/* The endpoint has always filtered by item; the dashboard's recent-movement rows
              link straight to one, so the filter needs a control to show for itself. */}
          <Select
            allowClear
            showSearch
            optionFilterProp="label"
            placeholder="Item"
            style={{ width: 260 }}
            options={items.map((i) => ({ value: i.id, label: fmtItem(i) }))}
            value={num("itemId")}
            onChange={(v) => set("itemId", v)}
          />
          <Select
            allowClear
            placeholder="Movement type"
            style={{ width: 200 }}
            options={MOVEMENT_TYPES.map((t) => ({ value: t, label: t.replaceAll("_", " ") }))}
            value={value("type")}
            onChange={(v) => set("type", v)}
          />
        </>
      )}
      columns={[
        { title: "Date", dataIndex: "createdAt", sorter: true, render: (v) => dayjs(v).format(DT_FORMATS.dateTime) },
        { title: "Location", render: (_, r) => r.location?.name },
        { title: "Code", render: (_, r) => r.item?.code },
        { title: "Item", render: (_, r) => r.item?.name },
        { title: "Type", render: (_, r) => r.txn?.eventType },
        { title: "Qty", dataIndex: "qtyDelta", sorter: true },
        { title: "Balance after", dataIndex: "balanceAfter", sorter: true },
        { title: "Ref", render: (_, r) => `${r.txn?.refType} #${r.txn?.refId}` },
      ]}
    />
  );
}
